/**
 * Frozen content identity for the next release candidate.
 *
 * This JavaScript module is intentionally shared by browser/API TypeScript and
 * Node-based release tooling so the version is defined in exactly one place.
 */
export const CURRENT_CONTENT_VERSION = "prd-0.9.27-m34";

